import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { useToasts } from "react-toast-notifications";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { useLazyQuery, useMutation } from "@apollo/client";
import AnimationLoading from "../../components/AnimationLoading";
import { COLOR_APP, S3_URL } from "../../constants";
import {
  faEdit,
  faImages,
  faLocationDot,
  faPen,
  faPhone,
  faEye,
  faTrash,
  faCirclePlus,
  faUsers,
  faBoxOpen,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { imageRender } from "../../helpers";
import moment from "moment";
import { Breadcrumb, Button, Modal, Spinner, Table } from "react-bootstrap";
import { POINTS } from "../../graphql/point/query";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import { GET_PRESIGN_URL } from "../../graphql/presignUrl/query";
import { SHOP } from "../../graphql/shop/queryShop";
import { UPDATE_SHOP } from "../../graphql/shop/mutation";
import {
  GET_USER_FOLLOWERS,
  GET_SHOP_SOLD_ORDER_COUNT,
  GET_SHOP_COMMENTS,
} from "../../graphql/shopStats/query";
import { numberFormat } from "../../helpers";
import LoadingSpinner from "../../components/LoadingSpinner";

function SettingsProfile() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const { height, width } = useWindowDimensions();

  const [shop, setShop] = useState({});
  const [userData, setUserData] = useState({});
  const [points, SetPoints] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [removeImage, setRemoveImage] = useState(false); // ຕັ້ງໃຈລຶບຮູບໂປຣໄຟລ໌

  //* ສະຖິຕິຮ້ານ — ຄືກັບໜ້າ sale page (about-us): ຜູ້ຕິດຕາມ / ຂາຍແລ້ວ / ຣີວິວ
  const [followerCount, setFollowerCount] = useState(0);
  const [totalSold, setTotalSold] = useState(null);
  const [reviewStats, setReviewStats] = useState({ average: 0, count: 0 });

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);
  const [getShop, { data: shopData, loading: shopLoading }] = useLazyQuery(
    SHOP,
    { fetchPolicy: "cache-and-network" },
  );
  const [getPoint, { data: pointData, loading: pointLoading }] = useLazyQuery(
    POINTS,
    { fetchPolicy: "cache-and-network" },
  );
  const [getShopFollowers] = useLazyQuery(GET_USER_FOLLOWERS, {
    fetchPolicy: "network-only",
  });
  const [getSoldOrderCount] = useLazyQuery(GET_SHOP_SOLD_ORDER_COUNT, {
    fetchPolicy: "cache-and-network",
  });
  const [getShopComments] = useLazyQuery(GET_SHOP_COMMENTS, {
    fetchPolicy: "cache-and-network",
  });
  const [updateShop] = useMutation(UPDATE_SHOP);

  useEffect(() => {
    getShopData();
    getPointData();
    getShopStats();
  }, []);

  useEffect(() => {
    setShop(shopData?.shop);
    SetPoints(pointData?.points?.data);
  }, [shopData, pointData]);

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  const getShopData = async () => {
    const shop_id = localStorage.getItem("SHOP");
    const _userData = JSON.parse(localStorage.getItem("USER_DATA"));
    setUserData(_userData.data);
    await getShop({
      variables: {
        where: {
          id: shop_id,
        },
      },
    });
  };

  const getPointData = async () => {
    const shop_id = localStorage.getItem("SHOP");
    await getPoint({
      variables: {
        where: {
          shop: shop_id,
        },
        orderBy: "createdAt_DESC",
        limit: 60,
        skip: 0,
      },
    });
  };

  //* ດຶງສະຖິຕິຮ້ານ (ຜູ້ຕິດຕາມ / ຂາຍແລ້ວ / ຣີວິວ) — ຂໍ້ມູນຈິງຈາກ backend ດຽວກັນກັບໜ້າ about-us
  const getShopStats = async () => {
    const shop_id = localStorage.getItem("SHOP");
    if (!shop_id) return;

    // ຈຳນວນຜູ້ຕິດຕາມ
    try {
      const res = await getShopFollowers({
        variables: { where: { followedShop: shop_id }, limit: 1 },
      });
      setFollowerCount(res?.data?.userFollowers?.total || 0);
    } catch (error) {
      console.log("followers error: ", error);
    }

    // ຈຳນວນອໍເດີ້ທີ່ຂາຍໄດ້ — ປິດການໃຊ້ຊົ່ວຄາວ (comment ອອກ card ຂາຍແລ້ວ)
    // try {
    //   const res = await getSoldOrderCount({
    //     variables: {
    //       where: {
    //         shop: shop_id,
    //         isDeleted: false,
    //         type: "SALE_PAGE",
    //         status: ["COMPLETED", "SHIPPINGCOMPLETED", "SHIPPING_COMPLETED"],
    //       },
    //       limit: 1,
    //       skip: 0,
    //     },
    //   });
    //   setTotalSold(res?.data?.orderGroups?.total ?? null);
    // } catch (error) {
    //   console.log("totalSold error: ", error);
    // }

    // ຣີວິວຮ້ານ — ຄັດເອົາສະເພາະ comment ທີ່ບໍ່ມີ product (review ຮ້ານ)
    try {
      const res = await getShopComments({
        variables: { where: { shop: shop_id } },
      });
      const all = res?.data?.comments?.data || [];
      const reviews = all.filter((c) => !c.product && !c.productVariant);
      if (reviews.length > 0) {
        const sum = reviews.reduce((s, c) => s + (Number(c.rate) || 0), 0);
        setReviewStats({
          average: sum / reviews.length,
          count: reviews.length,
        });
      } else {
        setReviewStats({ average: 0, count: 0 });
      }
    } catch (error) {
      console.log("reviews error: ", error);
    }
  };

  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          borderRadius: "100%",
          height: 200,
          width: 200,
        }}
      />
    );
  };

  //* ເປີດ modal ແກ້ໄຂ — reset ສະຖານະຮູບ ໃຫ້ສະອາດທຸກຄັ້ງ
  const openEditModal = () => {
    setRemoveImage(false);
    setFile(undefined);
    setFileName(undefined);
    setShowEditModal(true);
  };

  const handleUpload = async (event) => {
    try {
      setRemoveImage(false); // ອັບໂຫລດໃໝ່ = ຍົກເລີກການລຶບ
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const editShop = async (values) => {
    setIsLoading(true);
    const shop_id = localStorage.getItem("SHOP");
    await updateShop({
      variables: {
        data: {
          name: values?.name,
          //* ອັບໂຫລດໃໝ່ → fileName; ກົດລຶບ → "" (ລ້າງຮູບ); ບໍ່ດັ່ງນັ້ນ → ຮູບເກົ່າ
          image: fileName ? fileName : removeImage ? "" : shop.image,
          address: {
            district: values?.district,
            province: values?.province,
            village: values?.village,
          },
          phone: values?.phone,
          note: values?.note,
          updatedAt: moment(),
        },
        where: {
          id: shop_id,
        },
      },
    });

    const shopDataUpate = await getShop({
      variables: {
        where: {
          id: shop_id,
        },
      },
    });

    localStorage.setItem(
      "SHOP_DATA",
      JSON.stringify(shopDataUpate?.data?.shop),
    );

    setShowEditModal(false);
    setIsLoading(false);
    return addToast("ແກ້ໄຂຮ້ານສໍາເລັດ!", {
      appearance: "success",
      autoDismiss: true,
    });
  };

  if (shopLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Modal
        centered
        size="lg"
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
      >
        <Modal.Body>
          <Formik
            initialValues={{
              name: shop?.name || "",
              village: shop?.address?.village || "",
              district: shop?.address?.district || "",
              province: shop?.address?.province || "",
              phone: shop?.phone || "",
              note: shop?.note || "",
              image: shop?.image,
            }}
            onSubmit={(values) => {
              editShop(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 20,
                }}
              >
                <h3 style={{ fontWeight: "bold", textAlign: "center" }}>
                  ແກ້ໄຂຂໍ້ມູນຮ້ານ
                </h3>
                <div>
                  <input
                    type="file"
                    id="file-upload"
                    onChange={handleUpload}
                    hidden
                  />
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <label htmlFor="file-upload">
                      <div
                        style={{
                          background: "#fff",
                          height: "auto",
                          width: "100%",
                          border: "3px dashed " + COLOR_APP,
                          borderRadius: 8,
                          cursor: "pointer",
                          display: "flex",
                        }}
                      >
                        {file ? (
                          <ImageThumb image={file} />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              height: 150,
                              width: 150,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {!shop?.image || removeImage ? (
                              //* ຍັງບໍ່ມີຮູບ → ຊັກຊວນໃຫ້ກົດເພີ່ມ (ໄອຄອນ + ຂໍ້ຄວາມ + ເຄື່ອງໝາຍ +)
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <div style={{ position: "relative" }}>
                                  <FontAwesomeIcon
                                    icon={faImages}
                                    style={{ color: COLOR_APP, fontSize: 64 }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faCirclePlus}
                                    style={{
                                      position: "absolute",
                                      right: -6,
                                      bottom: -4,
                                      color: COLOR_APP,
                                      fontSize: 24,
                                      background: "#fff",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </div>
                                <span
                                  style={{
                                    fontSize: 12,
                                    color: COLOR_APP,
                                    fontWeight: 600,
                                  }}
                                >
                                  ເພີ່ມຮູບຮ້ານ
                                </span>
                              </div>
                            ) : (
                              <img
                                src={S3_URL + shop?.image}
                                style={{
                                  borderRadius: 8,
                                  height: 150,
                                  width: 150,
                                }}
                                alt="productImage"
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </label>

                    {/* ປຸ່ມລຶບຮູບ — ສະແດງເມື່ອມີຮູບ (ໃໝ່ ຫຼື ຮູບເກົ່າທີ່ຍັງບໍ່ໄດ້ລຶບ) */}
                    {(file || (shop?.image && !removeImage)) && (
                      <button
                        type="button"
                        title="ລຶບຮູບ"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setFile(undefined);
                          setFileName(undefined);
                          setRemoveImage(true);
                        }}
                        style={{
                          position: "absolute",
                          top: 6,
                          right: 6,
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          border: "none",
                          background: "#dc3545",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </div>
                  <div className="ml-2">ຊື່ຮ້ານ</div>
                  <input
                    className="form-control"
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    style={{
                      background: "#eee",
                      border: "none",
                      borderRadius: 10,
                    }}
                    placeholder="ໃສ່ຊື່ຮ້ານຄ້າຂອງທ່ານ..."
                  />
                </div>
                <div>
                  <div className="mt-4 ml-2 mb-2">ທີ່ຢູ່ຮ້ານ</div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: width > 700 ? "row" : "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div className="ml-2">ບ້ານ</div>
                      <input
                        className="form-control"
                        type="text"
                        name="village"
                        value={values.village}
                        onChange={handleChange}
                        style={{
                          background: "#eee",
                          border: "none",
                          borderRadius: 10,
                        }}
                        placeholder="ໃສ່ບ້ານ..."
                      />
                    </div>
                    <div>
                      <div>ເມືອງ</div>
                      <input
                        className="form-control"
                        type="text"
                        name="district"
                        value={values.district}
                        onChange={handleChange}
                        style={{
                          background: "#eee",
                          border: "none",
                          borderRadius: 10,
                        }}
                        placeholder="ໃສ່ເມືອງ..."
                      />
                    </div>
                    <div>
                      <div>ແຂວງ</div>
                      <input
                        className="form-control"
                        type="text"
                        name="province"
                        value={values.province}
                        onChange={handleChange}
                        style={{
                          background: "#eee",
                          border: "none",
                          borderRadius: 10,
                        }}
                        placeholder="ໃສ່ແຂວງ..."
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="ml-2">ເບີໂທລະສັບ</div>
                  <div
                    style={{
                      background: "#eee",
                      borderRadius: 10,
                      display: "flex",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        top: ".41em",
                        fontSize: 17,
                      }}
                    >
                      020
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      value={values.phone}
                      // onChange={handleChange}
                      onChange={(e) => {
                        const _phone = e?.target?.value;

                        if (isNaN(_phone) || _phone.length > 8) {
                          return;
                        }
                        handleChange(e);
                      }}
                      style={{
                        background: "#eee",
                        border: "none",
                        marginRight: 10,
                        paddingLeft: "3em",
                      }}
                      placeholder="ປ້ອນເບີໂທລະສັບ"
                    />
                  </div>
                </div>
                <div>
                  <div className="ml-2">ລາຍລະອຽດເພີ່ມເຕີມ</div>
                  <div style={{ background: "#eee", borderRadius: 10 }}>
                    <textarea
                      className="form-control text-area"
                      type="text"
                      name="note"
                      value={values.note}
                      onChange={handleChange}
                      style={{
                        background: "#eee",
                        border: "none",
                        marginRight: 10,
                      }}
                      placeholder="ໃສ່ລາຍລະອຽດເພີ່ມເຕີມຮ້ານຄ້າຂອງທ່ານ..."
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginTop: 50,
                  }}
                >
                  <Button
                    style={{
                      background: "#eee",
                      padding: width > 700 ? "10px 50px" : "7px 25px",
                      border: "none",
                      color: "#616161",
                      marginRight: 20,
                    }}
                    onClick={() => setShowEditModal(false)}
                  >
                    ຍົກເລີກ
                  </Button>
                  <Button
                    style={{
                      padding: width > 700 ? "10px 50px" : "7px 25px",
                      border: "none",
                      background: COLOR_APP,
                    }}
                    onClick={() => handleSubmit()}
                  >
                    {isLoading ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      "ບັນທືກ"
                    )}
                  </Button>
                </div>
              </div>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      {width > 700 ? (
        <div style={{ background: "#eee" }}>
          <div
            style={{
              margin: "30px 20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => history.replace("/settings")}>
                ຕັ້ງຄ່າ
              </Breadcrumb.Item>
              <Breadcrumb.Item active>ໂປຣຟາຍ</Breadcrumb.Item>
            </Breadcrumb>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "4px 5px 0px 0px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "center",
                  textAlign: "center",
                  padding: "20px 10px",
                  background: "#fff",
                  borderRadius: 10,
                  height: "95vh",
                  width: width / 3.5,
                }}
              >
                <img
                  alt="shopimage"
                  src={imageRender(shop?.image)}
                  height="100%"
                  width="100%"
                  style={{
                    objectFit: "cover",
                    alignSelf: "center",
                    width: "100%",
                    border: "1px solid #eee",
                    borderRadius: "100%",
                    height: "100%",
                    maxWidth: "140px",
                    maxHeight: "140px",
                  }}
                />
                <div className="row mt-2">
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    User:{" "}
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      wordBreak: "break-word",
                      padding: "0px 3px",
                    }}
                  >
                    {userData?.username ?? "-"}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    Password:{" "}
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      padding: "0px 3px",
                    }}
                  >
                    *********
                  </div>
                </div>
                {shop?.paymentType === "POINT" ? (
                  <div
                    className="row mt-4"
                    style={{
                      background: "#eee",
                      borderRadius: 5,
                      margin: "10px 4px",
                      padding: "10px 5px",
                    }}
                  >
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ຈໍານວນພ້ອຍ:{" "}
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        wordBreak: "break-word",
                        padding: "0px 3px",
                      }}
                    >
                      {new Intl.NumberFormat("en-US").format(shop?.point)}
                    </div>
                  </div>
                ) : (
                  <div
                    className="row mt-4"
                    style={{
                      background: "#eee",
                      borderRadius: 5,
                      margin: "10px 10px",
                      padding: "10px 5px",
                    }}
                  >
                    <div
                      className="col-6"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      ໄລຍະເວລາ:{" "}
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        wordBreak: "break-word",
                        padding: "0px 3px",
                      }}
                    >
                      {moment(shop?.startDate).format("DD/MM/YYYY") +
                        " ~ " +
                        moment(shopData?.endDate).format("DD/MM/YYYY")}
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  background: "#fff",
                  borderRadius: 10,
                  height: "95vh",
                  width: width,
                  padding: 20,
                  marginLeft: 20,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h1 style={{ fontWeight: "bold" }}>{shop?.name}</h1>
                  <Button
                    style={{
                      border: "none",
                      background: COLOR_APP,
                      color: "#fff",
                      width: 140,
                      height: 40,
                    }}
                    onClick={openEditModal}
                  >
                    <FontAwesomeIcon icon={faPen} className="mr-2" />
                    ແກ້ໄຂ
                  </Button>
                </div>
                <div style={{ display: "flex" }}>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="mr-2"
                    style={{ color: "orangered" }}
                  />
                  <div>{`ບ້ານ: ${shop?.address?.village ?? "-"}, ເມືອງ: ${
                    shop?.address?.district ?? "-"
                  }, ແຂວງ: ${shop?.address?.province ?? "-"}`}</div>
                </div>
                <div className="ml-4 mt-4">{shop?.note ?? "-"}</div>
                <h4 className="mt-4" style={{ fontWeight: "bold" }}>
                  Contact
                </h4>
                <div>{shop?.phone ?? "-"}</div>
                <h4 className="mt-4" style={{ fontWeight: "bold" }}>
                  ປະຫວັດການໃຊ້ Package
                </h4>
                {pointLoading ? (
                  <h3
                    style={{
                      color: "#616161",
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      alignItems: "center",
                      marginTop: 100,
                    }}
                  >
                    <Spinner size="lg" animation="border" />{" "}
                    ກໍາລັງໂຫລດຂໍ້ມູນຢູ່...
                  </h3>
                ) : (
                  <Table responsive>
                    <thead>
                      <tr style={{ background: "#eee" }}>
                        <th style={{ borderBottom: "none" }}>#</th>
                        <th style={{ borderBottom: "none" }}>ຈໍາວນວເງິນ</th>
                        <th style={{ borderBottom: "none" }}>ປະເພດ</th>
                        <th style={{ borderBottom: "none" }}>ວັນເວລາ</th>
                        <th style={{ borderBottom: "none" }}>ຫມາຍເຫດ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {points?.length > 0 &&
                        points?.map((point, index) => {
                          return (
                            <tr key={point + index}>
                              <td>{index + 1}</td>
                              <td>
                                {new Intl.NumberFormat("en-US").format(
                                  point?.money,
                                )}
                              </td>
                              <td>{point?.type}</td>
                              <td>
                                {moment(point?.createdAt).format("DD/MM/YYYY")}
                              </td>
                              <td>{point?.note ?? "-"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "60px 0px 10px 0px",
              background: "#fff",
            }}
          >
            <img
              alt="shopimage"
              src={imageRender(shop?.image)}
              style={{
                objectFit: "cover",
                alignSelf: "center",
                border: "1px solid #eee",
                borderRadius: "100%",
                width: "160px",
                height: "160px",
              }}
            />
            <div style={{ display: "flex" }}>
              <div
                className="col-6"
                style={{ display: "flex", justifyContent: "end" }}
              >
                User:{" "}
              </div>
              <div
                className="col-6"
                style={{ display: "flex", justifyContent: "start" }}
              >
                {userData?.username ?? "-"}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                className="col-6"
                style={{ display: "flex", justifyContent: "end" }}
              >
                Password:{" "}
              </div>
              <div
                className="col-6"
                style={{
                  display: "flex",
                  justifyContent: "start",
                  padding: "0px 3px",
                }}
              >
                *********
              </div>
            </div>
            {shop?.paymentType === "POINT" ? (
              <div
                className="row mt-4"
                style={{
                  background: "#eee",
                  borderRadius: 5,
                  margin: "10px 40px",
                  padding: "10px 5px",
                }}
              >
                <div
                  className="col-6"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    whiteSpace: "nowrap",
                  }}
                >
                  ຈໍານວນພ້ອຍ:{" "}
                </div>
                <div
                  className="col-6"
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    wordBreak: "break-word",
                    padding: "0px 3px",
                  }}
                >
                  {new Intl.NumberFormat("en-US").format(shop?.point)}
                </div>
              </div>
            ) : (
              <div
                className="row mt-4"
                style={{
                  background: "#eee",
                  borderRadius: 5,
                  margin: "40px 10px",
                  padding: "10px 5px",
                }}
              >
                <div
                  className="col-6"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  ໄລຍະເວລາ:{" "}
                </div>
                <div
                  className="col-6"
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    wordBreak: "break-word",
                    padding: "0px 3px",
                  }}
                >
                  {moment(shop?.startDate).format("DD/MM/YYYY") +
                    " ~ " +
                    moment(shopData?.endDate).format("DD/MM/YYYY")}
                </div>
              </div>
            )}
          </div>
          <div style={{ background: "#fff", margin: "5px 10px" }}>
            <h5 style={{ fontWeight: "bold", wordBreak: "break-word" }}>
              {shop?.name}
            </h5>
            <div style={{ display: "flex" }}>
              <FontAwesomeIcon
                icon={faLocationDot}
                className="mr-2"
                style={{ color: "orangered" }}
              />
              <div>{`ບ້ານ: ${shop?.address?.village ?? "-"}, ເມືອງ: ${
                shop?.address?.district ?? "-"
              }, ແຂວງ: ${shop?.address?.province ?? "-"}`}</div>
            </div>
            <div className="ml-4 mt-4">{shop?.note ?? "-"}</div>
            <h5 className="mt-4" style={{ fontWeight: "bold" }}>
              Contact
            </h5>
            <div>{userData?.phone}</div>
            <h5 className="mt-4" style={{ fontWeight: "bold" }}>
              ປະຫວັດການໃຊ້ Package
            </h5>
            <Table responsive>
              <thead>
                <tr style={{ background: "#eee", whiteSpace: "nowrap" }}>
                  <th style={{ borderBottom: "none" }}>#</th>
                  <th style={{ borderBottom: "none" }}>ຈໍາວນວເງິນ</th>
                  <th style={{ borderBottom: "none" }}>ປະເພດ</th>
                  <th style={{ borderBottom: "none" }}>ວັນເວລາ</th>
                  <th style={{ borderBottom: "none" }}>ຫມາຍເຫດ</th>
                </tr>
              </thead>
              <tbody>
                {points?.length > 0 &&
                  points?.map((point, index) => {
                    return (
                      <tr key={point + index}>
                        <td>{index + 1}</td>
                        <td>
                          {new Intl.NumberFormat("en-US").format(point?.money)}
                        </td>
                        <td>{point?.type}</td>
                        <td>{moment(point?.createdAt).format("DD/MM/YYYY")}</td>
                        <td>{point?.note ?? "-"}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
          <div
            style={{ marginLeft: 10, marginTop: 10 }}
            className="floating-container"
          >
            <div
              style={{ marginLeft: 10, marginTop: 10 }}
              className="floating-button"
            >
              <FontAwesomeIcon icon={faPen} onClick={openEditModal} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SettingsProfile;
